import * as tslib_1 from "tslib";
import chart from "./chart";
import dataService from "@/services/data";
import selectTimeRange from "@/components/selectTimeRange.vue";
import loader from "@/components/loader.vue";
import noDataOverlay from "@/components/noDataOverlay.vue";
import { Getter, Mutation } from "vuex-class";
import { Vue, Component, Watch } from "vue-property-decorator";
let widget = class widget extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.noDataAvailable = false;
        this.dbs = 10;
        this.high = 20;
        this.safe = 70;
        this.unsafe = 10;
        this.lastReq = {};
    }
    watchtimeRange() {
        this.updateData();
    }
    watchprofileIds() {
        this.updateData();
    }
    watchsoundSource() {
        this.updateData();
    }
    async mounted() {
        await this.updateData();
    }
    async updateData() {
        this.loading = true;
        this.noDataAvailable = false;
        // track last request
        this.lastReq = {};
        const lastReqLocal = this.lastReq;
        // get data
        let data = null;
        try {
            data = await dataService.getDaily({
                tz: this.tzName,
                source: this.soundSource,
                from_millis: this.timeRange.min,
                to_millis: this.timeRange.max
            });
        }
        catch (err) {
            this.setLastErr("Could not load Data: " + err);
            return;
        }
        // only let latest request pass
        if (this.lastReq !== lastReqLocal)
            return;
        data = data.Items.filter((v) => this.profileIds.find((p) => v.profile_id == p));
        if (data && data.length > 0) {
            let reduced = data.reduce((res, v) => {
                const isAdult = this.profileByID[v.profile_id].isAdult || false;
                const tmp = {
                    dba: res.dba + v.dba,
                    safe: res.safe + (isAdult ? v.safe_p1 : v.safe_p2),
                    unsafe: res.unsafe + (isAdult ? v.unsafe_p1 : v.unsafe_p2),
                    high: res.high + (isAdult ? v.high_p1 : v.high_p2),
                    total: 0
                };
                tmp.total = tmp.safe + tmp.unsafe + tmp.high;
                return tmp;
            }, {
                dba: 0,
                safe: 0,
                high: 0,
                unsafe: 0,
                total: 0
            });
            reduced.dba /= data.length;
            // console.log('dba:', reduced.dba)
            this.dbs = reduced.dba || 0;
            // console.log('safe:', reduced.safe)
            this.safe = (reduced.safe / reduced.total) * 100;
            // console.log('unsafe:', reduced.unsafe)
            this.unsafe = (reduced.unsafe / reduced.total) * 100;
            // console.log('high:', reduced.high)
            this.high = (reduced.high / reduced.total) * 100;
            // console.log('total:', reduced.total)
        }
        else {
            this.noDataAvailable = true;
            this.dbs = 0;
            this.safe = 60;
            this.unsafe = 10;
            this.high = 30;
        }
        this.loading = false;
    }
};
tslib_1.__decorate([
    Getter("tzName")
], widget.prototype, "tzName", void 0);
tslib_1.__decorate([
    Getter("config/selectedSoundSource")
], widget.prototype, "soundSource", void 0);
tslib_1.__decorate([
    Getter("config/dbDoughnutTimeRange")
], widget.prototype, "timeRange", void 0);
tslib_1.__decorate([
    Getter("config/profileIds")
], widget.prototype, "profileIds", void 0);
tslib_1.__decorate([
    Getter("auth/profileByID")
], widget.prototype, "profileByID", void 0);
tslib_1.__decorate([
    Mutation
], widget.prototype, "setLastErr", void 0);
tslib_1.__decorate([
    Watch("timeRange", { deep: true })
], widget.prototype, "watchtimeRange", null);
tslib_1.__decorate([
    Watch("profileIds", { deep: true })
], widget.prototype, "watchprofileIds", null);
tslib_1.__decorate([
    Watch("soundSource", { deep: true })
], widget.prototype, "watchsoundSource", null);
widget = tslib_1.__decorate([
    Component({
        components: {
            loader,
            chart: chart,
            "select-time-range": selectTimeRange,
            "no-data": noDataOverlay
        }
    })
], widget);
export default widget;
